// CORE API: salon_stripe_account_status

const STRIPE_STATUS = Object.freeze({
  noAccount: 'no_account',
  complete: 'complete',
  incomplete: 'incomplete',
  restricted: 'restricted',
});

// noinspection JSUnusedGlobalSymbols
export default STRIPE_STATUS;
